import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Breadcrumbs from '../components/Breadcrumbs';
import ContactForm from '../components/ContactForm';
import './ContactPage.css';

function ContactPage() {
  return (
    <div className="contact-page">
      <SEO
        title="Contact Us - Awnings & Pergolas Melbourne"
        description="Get a no-obligation quote on retractable awnings and pergola systems in Melbourne. Call +61 422 439 499, email us, or send photos and measurements."
        keywords="contact ASG Shading, awning supplier Melbourne, no-obligation quote, pergola enquiry"
        canonical="/contact"
        jsonLd={[SEO.localBusinessSchema, SEO.breadcrumbSchema([{ name: 'Contact' }]), SEO.webPageSchema({ type: 'ContactPage', name: 'Contact ASG Shading', description: 'Get in touch with ASG Shading for a no-obligation quote on premium retractable awnings and pergola systems in Melbourne.', url: '/contact' })]}
      />
      <section className="cp-hero">
        <div className="cp-hero-bg"></div>
        <div className="cp-hero-content">
          <p className="cp-label">Get in Touch</p>
          <h1 className="cp-title">Contact Us</h1>
          <p className="cp-subtitle">Have a question or ready to start your project? We'd love to hear from you.</p>
        </div>
      </section>

      <Breadcrumbs items={[{ name: 'Contact' }]} />

      <section className="cp-main">
        <div className="cp-main-inner">
          <div className="cp-info">
            <div className="cp-info-card">
              <h2>Remote Advice</h2>
              <p>Send us photos and measurements and we'll advise remotely - no site visit needed.</p>
            </div>
            <div className="cp-info-card">
              <h2>Phone</h2>
              <a href="tel:+61422439499">+61 422 439 499</a>
            </div>
            <div className="cp-info-card">
              <h2>Email</h2>
              <a href="mailto:info@asgshading.com.au">info@asgshading.com.au</a>
            </div>
            <div className="cp-info-card">
              <h2>Location</h2>
              <p>Hoppers Crossing, VIC 3029<br />Warehouse only - no showroom or walk-ins.<br />Delivery across Melbourne, freight Australia-wide.</p>
            </div>
          </div>

          <div className="cp-form-wrap">
            <ContactForm />
          </div>
        </div>
      </section>

      {/* The practical detail a first-time enquirer needs: what to send us,
          how a supply-only business works, and where the answers already
          live. Every fact here is repeated from the pages it links to. */}
      <section className="cp-more">
        <div className="cp-more-inner">
          <div className="cp-more-grid">
            <div className="cp-more-block">
              <h2>What to include in your message</h2>
              <p>The more we know about the space, the faster we can quote. For an awning, tell us:</p>
              <ul>
                <li>the width of the wall you want covered, and how far out you would like the shade to reach;</li>
                <li>what the wall is made of - brick, rendered, weatherboard or cladding;</li>
                <li>anything in the way, such as gutters, downpipes, lights or a door that swings out;</li>
                <li>two or three photos taken from a few metres back, and your suburb or postcode.</li>
              </ul>
              <p>For a pergola, the footprint you have in mind (width and depth), whether it will stand on its own or attach to the house, and photos of the area.</p>
              <p><Link to="/measuring-guide">Our measuring guide</Link> walks through each measurement step by step.</p>
            </div>
            <div className="cp-more-block">
              <h2>How we work</h2>
              <p>ASG Shading is a supply-only business. We build your awning or pergola kit to your measurements and deliver it; fitting is done by you or a tradesperson of your choice, and we do not do site visits. Photos and measurements are all we need to advise and quote remotely.</p>
              <p>Our Hoppers Crossing base is a warehouse rather than a showroom, so we cannot take walk-in visits - but every colour in the range is on the <Link to="/colours">colours page</Link>, and the <Link to="/for-installers">installer page</Link> has the manual, the wind report and everything a tradesperson needs to quote the job.</p>
            </div>
            <div className="cp-more-block">
              <h2>Delivery and after your order</h2>
              <p>Delivery is free to most of Melbourne, including Werribee, Point Cook, Williamstown, Footscray, Sunshine, Dandenong and Epping. Outer suburbs such as Geelong, Frankston, Pakenham and Berwick are a flat $150, and we quote freight for everywhere else, including interstate. <Link to="/delivery">Check your postcode</Link> before you order.</p>
              <p>If anything arrives damaged, short or wrong, tell us in writing within 2 business days with photos of the item and the packaging, and keep the packaging until it is sorted out. Our <Link to="/terms">terms</Link> set out the details.</p>
            </div>
          </div>

          <div className="cp-quick">
            <h2>Quick answers</h2>
            <p>These pages cover the questions we are asked most, if you would rather not wait for a reply:</p>
            <ul className="cp-quick-links">
              <li><Link to="/#faq">Common questions</Link> - wind ratings, lead times, deposits, permits and more</li>
              <li><Link to="/products/compare">Compare the models</Link> - every awning and pergola side by side</li>
              <li><Link to="/measuring-guide">Measuring guide</Link> - what to measure and how</li>
              <li><Link to="/delivery">Delivery zones</Link> - free, flat-rate and quoted areas</li>
              <li><Link to="/colours">Fabric colours</Link> - the full Sauleda range</li>
              <li><Link to="/request-quote">Request a quote</Link> - for a detailed written price</li>
            </ul>
            <p className="cp-business">ASG Shading · ABN 54 658 871 369 · Hoppers Crossing, VIC 3029</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ContactPage;
